/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export interface HelpCenterIconProps {
  iconSize?: IconSize | number;
  iconColor?: string;
  elementId?: string;
}

/*
 * Defines the Design Language System (DLS) Help Center Icon component.
 */
export const HelpCenterIcon = ({
  iconSize = 24,
  iconColor = dlsColor('grey3'),
  elementId
}: HelpCenterIconProps) => {
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id={elementId}>
      <circle cx="12" cy="12" r="11.0769" stroke={iconColor} strokeWidth="1.5"/>
      <path d="M12.6015 14.4177H10.8593C10.8645 13.9333 10.9062 13.527 10.9843 13.1989C11.0624 12.8656 11.1926 12.5635 11.3749 12.2927C11.5624 12.0218 11.8098 11.7354 12.1171 11.4333C12.3567 11.2041 12.5728 10.988 12.7655 10.7849C12.9583 10.5765 13.1119 10.3578 13.2265 10.1286C13.3411 9.89423 13.3984 9.626 13.3984 9.32391C13.3984 8.99579 13.3437 8.71714 13.2343 8.48798C13.1249 8.25881 12.9635 8.08433 12.7499 7.96454C12.5416 7.84475 12.2812 7.78485 11.9687 7.78485C11.7083 7.78485 11.4635 7.83693 11.2343 7.9411C11.0051 8.04006 10.8202 8.19631 10.6796 8.40985C10.539 8.61818 10.4635 8.89423 10.453 9.23798H8.57024C8.58065 8.58173 8.7369 8.02964 9.03899 7.58173C9.34107 7.13381 9.74732 6.79787 10.2577 6.57391C10.7682 6.34996 11.3385 6.23798 11.9687 6.23798C12.6666 6.23798 13.2629 6.35777 13.7577 6.59735C14.2525 6.83173 14.6301 7.17548 14.8905 7.6286C15.1562 8.07652 15.289 8.61818 15.289 9.2536C15.289 9.71193 15.1978 10.1286 15.0155 10.5036C14.8333 10.8734 14.5963 11.2197 14.3046 11.5427C14.0129 11.8604 13.6978 12.1781 13.3593 12.4958C13.0676 12.7614 12.8697 13.0505 12.7655 13.363C12.6614 13.6703 12.6067 14.0218 12.6015 14.4177ZM10.703 16.8552C10.703 16.5739 10.7994 16.3369 10.9921 16.1442C11.1848 15.9463 11.4478 15.8474 11.7812 15.8474C12.1145 15.8474 12.3775 15.9463 12.5702 16.1442C12.7629 16.3369 12.8593 16.5739 12.8593 16.8552C12.8593 17.1364 12.7629 17.376 12.5702 17.5739C12.3775 17.7666 12.1145 17.863 11.7812 17.863C11.4478 17.863 11.1848 17.7666 10.9921 17.5739C10.7994 17.376 10.703 17.1364 10.703 16.8552Z" fill={iconColor}/>
    </svg>

  );
};
